import * as ActionTypes from './../constants';
import axios from 'axios'; 
import {baseUrl } from '../index'; 
import { getUserToken } from './../getUserToken';


 

export default function (state = {}, action){

    switch(action.type){
        case ActionTypes.REQUEST_TEST_ANALYSIS:
        return {
            ...state,
            loading:true,
            error:false,
            errorInfo:null,
            requestedTestId: action.testId,
            response: null
        }

        case ActionTypes.RECEIVED_TEST_ANALYSIS:
        return {
            ...state,
            loading:false,
            response:action.res,
            error:false,
            errorInfo:null
        }

        case ActionTypes.ERROR_TEST_ANALYSIS:
        return {
            ...state,
            loading:false,
            error:true,
            errorInfo:action.err,
            response: null
        }

        case ActionTypes.CLEAR_TEST_ANALYSIS:
        return {}
        default: return state;
    }

}



const dispatchRequestTestAnalysis = testId => ({
        type:ActionTypes.REQUEST_TEST_ANALYSIS,
        testId
})

const dispatchReceivedTestAnalysis = res =>({
    type:ActionTypes.RECEIVED_TEST_ANALYSIS,
    res
})

const dispatchErrorTestAnalysis = (err) => ({
    type:ActionTypes.ERROR_TEST_ANALYSIS,
    err
})

const dispatchClearTestAnalysis= () => ({
    type: ActionTypes.CLEAR_TEST_ANALYSIS
})

export const clearTestAnalysisData = () => dispatchClearTestAnalysis();

export const testAnalysis = (testId, isPlannedTest, isTestSeries, isMaterialTest) => dispatch => {    

    dispatch(dispatchRequestTestAnalysis(testId));

    let _testId = testId;

    if(typeof testId === 'object') {
        _testId = testId.test_id || testId.event_id || testId.mock_test_id || testId.material_test_id
    }   

    const data = {
        test_id: _testId,
        mock_test_id: _testId,
        material_test_id: _testId
    }

    console.log(data, 'from test analysis');

    const endPoint = isPlannedTest ? 'planned_test_analysis' : isTestSeries ? 'mock_test_analysis' : isMaterialTest ? 'materialTestAnalysis' : 'testanalysis'

    // plannedTestEndPoint = planned_test_analysis

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'post',
                url: `${baseUrl}/api/${endPoint}`,
                data,
                headers: {
                    'Authorization': `Bearer ${authKey}`
                }
            }
            return axios(options)
                .then(({data}) => {
                    dispatch(dispatchReceivedTestAnalysis(data))
                })
                
        })
        .catch(e => {            
            dispatch(dispatchErrorTestAnalysis(e.response))
        });    
}
